import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
  Box,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { ArrowForwardIos, Reply } from "@mui/icons-material";
import { basicUTCFormat } from "../../extends/NumberFormat";

const ReplyComments = ({ replies = [], onReply }) => {
  const [expanded, setExpanded] = useState(false);

  const handleOnChange = (e, isExpanded) => {
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion
      disableGutters
      elevation={0}
      square
      onChange={handleOnChange}
      expanded={expanded}
    >
      <AccordionSummary
        expandIcon={
          <ArrowForwardIos sx={{ fontSize: "0.9rem" }}></ArrowForwardIos>
        }
        sx={{
          flexDirection: "row-reverse",
          gap: 1,
          "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(90deg)",
          },
        }}
      >
        <Typography>Replies</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ ml: 1, pt: 0 }}>
        <List dense sx={{ m: 0, p: 0 }}>
          {replies.map((c, i) => (
            <ListItem
              key={c?.id}
              sx={{
                alignItems: "flex-start",
                flexDirection: c.isCatererReply && "row-reverse",
              }}
            >
              {!c.isCatererReply && (
                <ListItemAvatar sx={{ minWidth: 70 }}>
                  <Stack gap={0.5} alignItems="center">
                    <Avatar></Avatar>
                    {!c.isCatererReply && !c?.isArchived && (
                      <IconButton
                        size="small"
                        color="primary"
                        sx={{ p: 0 }}
                        onClick={() => onReply && onReply(c)}
                      >
                        <Reply fontSize="inherit"></Reply>
                        <Typography variant="caption">Reply</Typography>
                      </IconButton>
                    )}
                    {!c.isCatererReply && c?.isArchived && (
                      <Chip
                        size="small"
                        color="success"
                        variant="contained"
                        sx={{ "&.MuiChip-root": { height: 18 } }}
                        label={
                          <Typography variant="caption">Replied</Typography>
                        }
                      ></Chip>
                    )}
                  </Stack>
                </ListItemAvatar>
              )}
              <ListItemText
                disableTypography
                sx={{
                  textAlign: c.isCatererReply ? "right" : "",
                  mr: c.isCatererReply && 2,
                }}
                primary={
                  <Stack
                    direction="row"
                    alignItems="flex-start"
                    justifyContent={c.isCatererReply ? "end" : null}
                  >
                    <Box
                      sx={{
                        whiteSpace: "pre-wrap",
                        maxHeight: 150,
                        overflow: "auto",
                        borderRadius: 2,
                        color: c.isCatererReply ? "#fff" : null,
                        bgcolor: c.isCatererReply ? "info.light" : "#eee",
                        p: 1,
                      }}
                    >
                      {c?.content}
                    </Box>
                  </Stack>
                }
                secondary={
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent={c.isCatererReply ? "end" : null}
                    sx={{ pt: 0.5 }}
                  >
                    <Typography variant="caption">
                      {basicUTCFormat(c?.recAddedDate)}
                    </Typography>
                  </Stack>
                }
              ></ListItemText>
            </ListItem>
          ))}
        </List>
        <Stack>
          <Button
            onClick={() => {
              onReply && onReply();
            }}
          >
            Add New Reply
          </Button>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default ReplyComments;
